import SwitchAttendanceCountVisibility from "./SwitchAttendanceCountVisibility";
import SwitchType from "./SwitchType";
import SwitchCategory from "./SwitchCategory";
import SwitchTargets from "./SwitchTargets";
import {
    formatEventDate,
    formatEventTime,
    isPastEvent,
} from "./calendarEventUtils";

function DeleteEventButton({ event, socket }) {
    const handleDeleteEvent = () => {
        const confirm = window.confirm(`Estàs segur que vols eliminar l'event ${event.title}? Aquesta acció no es pot desfer.`);

        if (confirm) {
            socket.emit('.delete_event', event.id);
        }
    };

    return (
        <button
            type="button"
            className="calendar-delete-event-button"
            onClick={handleDeleteEvent}
        >
            Eliminar
        </button>
    );
}

function CalendarEventActions({ event, socket, toBeDeleted }) {
    if (!toBeDeleted) {
        return (
            <span className="calendar-event-muted">
                Per eliminar-lo, elimina'l primer del Google Calendar.
            </span>
        );
    }

    return (
        <>
            <div className="calendar-event-delete-warning">
                Aquest esdeveniment no s'ha trobat a Google Calendar.
            </div>
            <DeleteEventButton event={event} socket={socket} />
        </>
    );
}

function CalendarEventRow({
    event,
    eventCategories,
    socket,
    toBeDeleted,
    now,
    onRowRef,
}) {
    const rowClassName = [
        'calendar-event-row',
        toBeDeleted ? 'calendar-event-row-to-delete' : '',
        isPastEvent(event, now) ? 'calendar-event-row-past' : '',
    ].filter(Boolean).join(' ');

    return (
        <tr
            className={rowClassName}
            ref={element => onRowRef?.(event, element)}
        >
            <td className="calendar-event-date-cell">
                {formatEventDate(event)}
            </td>
            <td className="calendar-event-time-cell">
                {formatEventTime(event)}
            </td>
            <td className="calendar-event-title-cell">
                <div className="calendar-event-title">
                    {event["gcalendar-link"] ? (
                        <a href={event["gcalendar-link"]} target="_blank" rel="noopener noreferrer">
                            {event.title || `Esdeveniment #${event.id}`}
                        </a>
                    ) : (
                        event.title || `Esdeveniment #${event.id}`
                    )}
                </div>
                {event.description ? (
                    <div
                        className="calendar-event-description"
                        dangerouslySetInnerHTML={{ __html: event.description }}
                    />
                ) : null}
            </td>
            <td className="calendar-event-place-cell">
                {event.lloc ? (
                    <a href={`https://maps.google.com/?q=${encodeURIComponent(event.lloc)}`} target="_blank" rel="noopener noreferrer">
                        {event.lloc}
                    </a>
                ) : (
                    <span className="calendar-event-muted">A determinar</span>
                )}
            </td>
            <td className="calendar-event-control-cell">
                <SwitchType event={event} socket={socket} />
            </td>
            <td className="calendar-event-control-cell">
                <SwitchCategory event={event} socket={socket} eventCategories={eventCategories} />
            </td>
            <td className="calendar-event-targets-cell">
                <SwitchTargets event={event} socket={socket} />
            </td>
            <td className="calendar-event-control-cell">
                <SwitchAttendanceCountVisibility event={event} socket={socket} />
            </td>
            <td className="calendar-event-actions-cell">
                <CalendarEventActions event={event} socket={socket} toBeDeleted={toBeDeleted} />
            </td>
        </tr>
    );
}

export default CalendarEventRow;
